var _a;
import { Us_State_Name } from 'generated/types';
import { enumValuesFactory } from 'utils/objectHelper';
var enumDescriptionMap = (_a = {},
    _a[Us_State_Name.Ak] = 'Alaska',
    _a[Us_State_Name.Al] = 'Alabama',
    _a[Us_State_Name.Ar] = 'Arkansas',
    _a[Us_State_Name.As] = 'American Samoa',
    _a[Us_State_Name.Az] = 'Arizona',
    _a[Us_State_Name.Ca] = 'California',
    _a[Us_State_Name.Co] = 'Colorado',
    _a[Us_State_Name.Ct] = 'Connecticut',
    _a[Us_State_Name.Dc] = 'District Of Columbia',
    _a[Us_State_Name.De] = 'Delaware',
    _a[Us_State_Name.Fl] = 'Florida',
    _a[Us_State_Name.Fm] = 'Federated States Of Micronesia',
    _a[Us_State_Name.Ga] = 'Georgia',
    _a[Us_State_Name.Gu] = 'Guam',
    _a[Us_State_Name.Hi] = 'Hawaii',
    _a[Us_State_Name.Ia] = 'Iowa',
    _a[Us_State_Name.Id] = 'Idaho',
    _a[Us_State_Name.Il] = 'Illinois',
    _a[Us_State_Name.In] = 'Indiana',
    _a[Us_State_Name.Ks] = 'Kansas',
    _a[Us_State_Name.Ky] = 'Kentucky',
    _a[Us_State_Name.La] = 'Louisiana',
    _a[Us_State_Name.Ma] = 'Massachusetts',
    _a[Us_State_Name.Md] = 'Maryland',
    _a[Us_State_Name.Me] = 'Maine',
    _a[Us_State_Name.Mh] = 'Marshall Islands',
    _a[Us_State_Name.Mi] = 'Michigan',
    _a[Us_State_Name.Mn] = 'Minnesota',
    _a[Us_State_Name.Mo] = 'Missouri',
    _a[Us_State_Name.Mp] = 'Northern Mariana Islands',
    _a[Us_State_Name.Ms] = 'Mississippi',
    _a[Us_State_Name.Mt] = 'Montana',
    _a[Us_State_Name.Nc] = 'North Carolina',
    _a[Us_State_Name.Nd] = 'North Dakota',
    _a[Us_State_Name.Ne] = 'Nebraska',
    _a[Us_State_Name.Nh] = 'New Hampshire',
    _a[Us_State_Name.Nj] = 'New Jersey',
    _a[Us_State_Name.Nm] = 'New Mexico',
    _a[Us_State_Name.Nv] = 'Nevada',
    _a[Us_State_Name.Ny] = 'New York',
    _a[Us_State_Name.Oh] = 'Ohio',
    _a[Us_State_Name.Ok] = 'Oklahoma',
    _a[Us_State_Name.Or] = 'Oregon',
    _a[Us_State_Name.Pa] = 'Pennsylvania',
    _a[Us_State_Name.Pr] = 'Puerto Rico',
    _a[Us_State_Name.Pw] = 'Palau',
    _a[Us_State_Name.Ri] = 'Rhode Island',
    _a[Us_State_Name.Sc] = 'South Carolina',
    _a[Us_State_Name.Sd] = 'South Dakota',
    _a[Us_State_Name.Tn] = 'Tennessee',
    _a[Us_State_Name.Tx] = 'Texas',
    _a[Us_State_Name.Ut] = 'Utah',
    _a[Us_State_Name.Va] = 'Virginia',
    _a[Us_State_Name.Vi] = 'Virgin Islands',
    _a[Us_State_Name.Vt] = 'Vermont',
    _a[Us_State_Name.Wa] = 'Washington',
    _a[Us_State_Name.Wi] = 'Wisconsin',
    _a[Us_State_Name.Wv] = 'West Virginia',
    _a[Us_State_Name.Wy] = 'Wyoming',
    _a);
export var UsStateNameEnum = {
    name: 'Us_State_Name',
    enumValues: enumValuesFactory(enumDescriptionMap)
};
